module.exports = __webpack_public_path__ + "static/media/os.865f063c.png";